import type { AIMessage, Message } from '@/features/AIChat/types/chat';

export default function isAiMessage(message: Message | undefined): message is AIMessage {
  return message?.sender === 'ai';
}
